var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"redirec__view"},[_c('v-progress-circular',{attrs:{"size":170,"width":15,"color":"#f1830d","indeterminate":""}}),_c('div',{staticClass:"mt-10 label-connexion"},[_vm._v("Connexion")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }